/* track.js — capa de MEDICIÓN del MVP. Conecta los data-track markers (puestos en
   el build) a GA4 / GTM / Shopify Customer Events / Microsoft Clarity.
   Spec: HIPOTESIS-TESTS.md §"Higiene de medición" #4 (tracking plan de eventos).

   Reglas duras de esta capa:
   - INVISIBLE: no pinta nada, no cambia layout, nunca lanza (todo en try/catch).
   - AGNÓSTICA al wiring: empuja a cualquier destino que exista (dataLayer/gtag/
     Shopify.analytics.publish/clarity). Si un destino no está, es no-op.
   - SEGURA en QA: con window.__TRACK_DEBUG = true NO manda hits reales (solo llena
     window.__trackLog), para verificar sin ensuciar GA4 antes del launch.
   Diccionario evento→hipótesis: ver INSTRUMENTACION.md. */
(function () {
  "use strict";
  window.__trackLog = window.__trackLog || [];

  /* --- exclusión de tráfico interno (equipo) por COOKIE, sin depender de IP ---
     El equipo abre `commonsmx.com/?equipo=1` UNA vez por dispositivo → cookie de 2 años →
     de ahí en adelante sus visitas no mandan hits. Robusto a IP dinámica/móvil. */
  function getCookie(n) { try { var m = document.cookie.match("(?:^|; )" + n + "=([^;]*)"); return m ? m[1] : null; } catch (e) { return null; } }
  function isInternal() { return getCookie("commons_internal") === "1"; }
  try {
    var _sp = new URLSearchParams(location.search);
    if (_sp.get("equipo") === "1") {
      document.cookie = "commons_internal=1; max-age=63072000; path=/; samesite=lax"; /* 2 años */
      _sp.delete("equipo"); /* limpia el param para no compartirlo por accidente */
      if (window.history && history.replaceState) {
        var _qs = _sp.toString();
        history.replaceState(null, "", location.pathname + (_qs ? "?" + _qs : "") + location.hash);
      }
    }
  } catch (e) {}

  function send(name, params) {
    params = params || {};
    /* QA (__TRACK_DEBUG) o tráfico interno del equipo: no se manda ningún hit real */
    if (window.__TRACK_DEBUG || isInternal()) return;
    /* 1) dataLayer (GTM-ready) — inofensivo si no hay contenedor GTM */
    try { (window.dataLayer = window.dataLayer || []).push(assign({ event: name }, params)); } catch (e) {}
    /* 2) gtag (GA4 directo, si hay tag global) */
    try { if (typeof window.gtag === "function") window.gtag("event", name, params); } catch (e) {}
    /* 3) Shopify Customer Events (custom pixel) — si el bridge existe en el storefront */
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish(name, params);
      }
    } catch (e) {}
    /* 4) Microsoft Clarity — custom event + tags (para segmentar replays/heatmaps) */
    try {
      if (typeof window.clarity === "function") {
        window.clarity("event", name);
        for (var k in params) {
          if (params.hasOwnProperty(k)) {
            var v = params[k];
            if (v != null && typeof v !== "object") window.clarity("set", k, String(v));
          }
        }
      }
    } catch (e) {}
  }

  function assign(a, b) { for (var k in b) if (b.hasOwnProperty(k)) a[k] = b[k]; return a; }

  function emit(name, params) {
    try {
      window.__trackLog.push({ name: name, params: params || {}, t: (window.performance && performance.now) ? Math.round(performance.now()) : 0 });
    } catch (e) {}
    send(name, params);
  }
  window.Track = { emit: emit };

  /* --- mapa marker (data-track) → evento GA4 + params base ---
     Los markers del EMBUDO se emiten con params ricos desde el código (pdp.js/ui.js/
     main-search) y se excluyen aquí para no duplicar. */
  var EXPLICIT = { "add-to-cart": 1, "checkout-handoff": 1 };
  var MAP = {
    "guia-tallas":        { ev: "size_guide_open" },
    "fake-door-talla":    { ev: "fake_door", p: { location: "pdp_size" } },
    "fake-door-marcas":   { ev: "fake_door", p: { location: "brands" } },
    "fake-door-coleccion":{ ev: "fake_door", p: { location: "collection" } },
    "fake-door-busqueda": { ev: "fake_door", p: { location: "search" } },
    "menu-whatsapp":      { ev: "whatsapp_click", p: { location: "menu" } },
    "garantia-whatsapp":  { ev: "whatsapp_click", p: { location: "warranty" } },
    "tienda-whatsapp":    { ev: "whatsapp_click", p: { location: "store" } },
    "hero-cta":           { ev: "cta_click", p: { location: "hero" } },
    "footer-instagram":   { ev: "social_click", p: { network: "instagram" } },
    "buscador-abrir":     { ev: "search_open" },
    "buscador-resultado": { ev: "select_item", p: { location: "search" } }
  };

  document.addEventListener("click", function (e) {
    var el = e.target && e.target.closest ? e.target.closest("[data-track]") : null;
    if (!el) return;
    var m = el.getAttribute("data-track");
    if (!m || EXPLICIT[m]) return; /* embudo: se emite con params ricos aparte */
    var cfg = MAP[m];
    var params = {};
    if (cfg && cfg.p) assign(params, cfg.p);
    /* enriquecer con data-track-* del elemento (ej. size del fake-door de talla) */
    try {
      if (el.dataset) {
        for (var d in el.dataset) {
          if (el.dataset.hasOwnProperty(d) && d.indexOf("track") === 0 && d !== "track") {
            params[d.slice(5).toLowerCase()] = el.dataset[d];
          }
        }
      }
    } catch (er) {}
    emit(cfg ? cfg.ev : "ui_interaction", cfg ? params : assign({ action: m }, params));
  }, true);

  /* --- visibilidad (IntersectionObserver, una vez por elemento) ---
     cinta de confianza (H2.5) + landed-cost (H2.4). */
  function observeOnce(sel, ev, params) {
    var nodes = document.querySelectorAll(sel);
    if (!nodes.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { emit(ev, params || {}); io.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    nodes.forEach(function (n) { io.observe(n); });
  }
  function boot() {
    /* si es interno, marca la sesión para el filtro nativo de GA4 (Internal Traffic):
       así, cuando actives ese filtro, la SESIÓN del equipo también se cae del denominador */
    if (isInternal()) { try { if (typeof window.gtag === "function") window.gtag("set", { traffic_type: "internal" }); } catch (e) {} }
    observeOnce('[data-track="cinta-confianza"]', "trust_ribbon_view");
    observeOnce('[data-track="landed-cost"]', "landed_cost_view");
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();
